import React from 'react';
import { useSelector } from 'react-redux';

function Result(props) {
  const result = useSelector((state) => state.selfDiagnosisReducer.result);
  const percentage = useSelector(
    (state) => state.selfDiagnosisReducer.percentage
  );
  return (
    <div>
      <div
        style={{
          textAlign: 'center',
          color: 'green',
          fontWeight: 'bold',
          fontSize: 20,
          marginTop: 20,
          marginBottom: 40,
        }}
      >
        {result[0] ? result[0].disease : 'Disease not identified'}
      </div>
      <div style={{ fontSize: 14 }}>
        This diagnosis has an accuracy of {percentage}
      </div>
    </div>
  );
}

export default Result;
